// @ts-nocheck
/* eslint-disable */
export const flFlagIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 20.2504V4.50037" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.75 15.7505C9.75 11.2505 14.25 20.2505 20.25 15.7505V4.50045C14.25 9.00045 9.75 0.000454098 3.75 4.50045" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'flag' as const
};